export default "/_next/static/images/b540a2dee48ba8a869ec7a22c5404799.png";